import React from "react";
import InBodyMultipleInformationDialog from "@icoach/inbody/dialog/InBodyMultipleInformationDialog";

const InBodyInterviewMultipleInformationDialog = props => {
	const { sourceData, isShow } = props;
	const { measureID, memberID, measureDate } = sourceData;

	if (!isShow) return null;
	
	return <InBodyMultipleInformationDialog sourceData={{ measureID, memberID, measureDate }} />;
};

export default InBodyInterviewMultipleInformationDialog;